import { oauthCompletePopupView } from './oauth-complete-popup.view';
/**
 * Prompt shown on return from the auth domain that lets the user finish the OAuth
 * handshake. The final step opens the auth domain's token page in a popup, and
 * browsers only allow `window.open` inside a user gesture, so the exchange can't
 * run automatically on page load — it's triggered from this button's click.
 * Self-contained: builds its own backdrop + container under `#main-container`.
 */
export class OauthCompletePopup {
    constructor(handlers) {
        this.handlers = handlers;
        this.pending = false;
        this.parent = document.getElementById('main-container');
        if (!this.parent) {
            console.error('Can\'t find container for popup - "#main-container"');
            this.backdrop = null;
            this.actionButton = null;
            this.errorEl = null;
            return;
        }
        this.onActionClick = this.onActionClick.bind(this);
        this.onKeyDown = this.onKeyDown.bind(this);
        this.backdrop = document.createElement('div');
        this.backdrop.className = 'popup-backdrop oauth-session-popup-backdrop';
        const view = oauthCompletePopupView();
        this.backdrop.appendChild(view);
        this.actionButton = view.querySelector('.oauth-complete-popup-action');
        this.errorEl = view.querySelector('.oauth-complete-popup-error');
        this.handleEvents();
        this.parent.appendChild(this.backdrop);
    }
    handleEvents() {
        var _a, _b;
        // Clicking the backdrop (outside the popup) or the close button dismisses it.
        (_a = this.backdrop) === null || _a === void 0 ? void 0 : _a.addEventListener('click', event => {
            const target = event.target;
            if (target === this.backdrop || target.closest('.overlay-button-close')) {
                this.cancel();
            }
        });
        (_b = this.actionButton) === null || _b === void 0 ? void 0 : _b.addEventListener('click', this.onActionClick);
        document.addEventListener('keydown', this.onKeyDown);
    }
    /**
     * Kick off the token exchange. `onComplete()` is called synchronously here so
     * the `window.open` it performs stays inside this click's user activation —
     * do not introduce an `await` before it.
     */
    onActionClick() {
        if (this.pending) {
            return;
        }
        this.pending = true;
        this.setError(null);
        this.setActionState(true, 'Completing…');
        this.handlers
            .onComplete()
            .then(() => {
            this.close();
            this.handlers.onSuccess();
        })
            .catch((error) => {
            this.pending = false;
            this.setActionState(false, 'Complete sign-in');
            this.setError((error === null || error === void 0 ? void 0 : error.message) || 'Sign-in failed. Please try again.');
        });
    }
    setActionState(disabled, label) {
        if (!this.actionButton) {
            return;
        }
        this.actionButton.disabled = disabled;
        this.actionButton.textContent = label;
    }
    setError(message) {
        if (!this.errorEl) {
            return;
        }
        this.errorEl.textContent = message !== null && message !== void 0 ? message : '';
        this.errorEl.hidden = !message;
    }
    onKeyDown(event) {
        if (event.key === 'Escape') {
            this.cancel();
        }
    }
    cancel() {
        if (this.pending) {
            return;
        }
        this.close();
        this.handlers.onCancel();
    }
    close() {
        var _a;
        document.removeEventListener('keydown', this.onKeyDown);
        (_a = this.backdrop) === null || _a === void 0 ? void 0 : _a.remove();
    }
}
